module.exports = __webpack_public_path__ + "img/ThumbsDownIcon.b4dd5980.svg";